<template>
  <a-spin :spinning="loading">
    <div class="spin-content">
      <slot>
        <component
          :is="formComponent"
          v-model="form"
          :errors="errors"
          :isDirty="isDirty"
          :edited="edited"
          @submit="onSubmit"
        />
      </slot>
    </div>
  </a-spin>
</template>
<script>
import { isFunction } from 'lodash'
export default {
  data() {
    return {
      loading: false,
      isDirty: false
    }
  },
  props: {
    errors: {
      type: [Object, Array],
      default: () => ({})
    },
    form: {
      type: [Object, Array],
      default: () => ({})
    },
    objParams: {
      type: [Object, String, Number],
      required: false
    },
    formComponent: {
      type: Object,
      required: true
    },
    service: {
      type: [Object, Function],
      required: true
    },
    getSuccessRoute: {
      type: Function,
      required: false
    },
    successMessage: {
      type: String,
      default: 'Zmiany zapisane'
    },
    editedMessage: {
      type: String,
      default: ''
    },
    edited: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    fetchData() {
      this.loading = true
      this.service
        .get(this.objParams)
        .then(res => {
          this.$emit('update:form', res.data)
        })
        .finally(() => {
          this.isDirty = false
          this.loading = false
        })
    },
    onSubmit() {
      this.loading = true
      this.$emit('update:errors', {})
      this.getSavePromise()
        .then(this.success)
        .catch(err => {
          this.$emit('update:errors', err.response.data)
        })
        .finally(() => {
          this.loading = false
        })
    },
    success(res) {
      this.isDirty = false
      if (this.successMessage) {
        if (this.edited)
          this.$notification.success({
            message: this.editedMessage || this.successMessage
          })
        else this.$notification.success({ message: this.successMessage })
      }
      if (this.getSuccessRoute && this.getSuccessRoute(res)) {
        this.$router.push(this.getSuccessRoute(res))
      }
      this.$emit('formSubmitted')
    },
    getSavePromise() {
      let func = null
      if (isFunction(this.service)) {
        func = this.service
      } else {
        func = this.objParams ? this.service.update : this.service.save
      }
      return this.objParams ? func(this.objParams, this.form) : func(this.form)
    }
  },
  watch: {
    objParams: {
      immediate: true,
      handler(value) {
        if (value) {
          this.fetchData()
        }
      }
    },
    form: {
      deep: true,
      handler() {
        this.isDirty = true
      }
    }
  }
}
</script>
